import { UseFormRegister } from "react-hook-form";
import { Toggle } from "@/components/ui/form";

/* Prop Types */
interface VisibilityToggleProps {
  register: UseFormRegister<any>;
  checked: boolean;
}

/*
 * VisibilityToggle component
 * Simple component used to toggle the visibility of a project on create and update modals
 */
export const VisibilityToggle = ({ register, checked }: VisibilityToggleProps) => {
  /* Render */
  return (
    <div className="rounded-md bg-base-200 p-4">
      <div className="flex items-center">
        <p className="mr-2">Make it private</p>
        <Toggle variant="primary" size="small" className="ml-5" defaultChecked={checked} registration={register("visibility")} />
      </div>
      <p className="text-sm opacity-70 mt-2">If you make this project private, only you will be able to see it.</p>
    </div>
  );
};
